module.exports = __webpack_public_path__ + "static/media/2eadb4c4-c43d-42dc-804a-c35da5df189a.d72c355c.JPG";